import React from 'react';
import flags from "../../featureFlags";
import { sendLoggingV4Request, loadScript} from "../../utility";
import { getProfileData, getBaseUrl } from 'data/DataStore';
import { getJsonData } from '../../data/DataStore';
import { getTitleUi } from "../../data/TitleInfoSelector";
import { AnalyticsWrapper } from '@novelist/novum-novella-ui';

import './AnalyticsWrapperContainer.less';

const AnalyticsWrapperContainer = (props) => {
	const profileData = getProfileData();
	const trackedInformation = {
        profileInfo: {profile: profileData.Profile, password: profileData.Password},
        logBaseUrl: getBaseUrl(),
        mainRecordUi: getTitleUi(getJsonData()),
        componentName: props.componentName,
        featureType: props.featureType
      };


	return (
		<div className='novum-wrapper-container' >
			<AnalyticsWrapper
				Component={props.Component}
				trackedInformation={trackedInformation}
				sendLogRequest={flags.useNewLogging()? sendLoggingV4Request : loadScript}
			/>
		</div>
	);
}

export default AnalyticsWrapperContainer; 


// WEBPACK FOOTER //
// ./src/react/containers/AnalyticsWrapperContainer.jsx